import React, { Component, createRef } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IAction, IAppState } from '../../models/action/core';
import * as Actions from '../../store/actions/profile';
import Input from '../../components/input/text/input-formik';
import {Log} from 'ng2-logger';
import { getValidation } from '../../models/validations/profile-password-question-validation';
import { IChangePasswordQuestion } from '../../models/pages/profile';
import * as types from '../../models/action/profile';
import Loading from '../../components/loading/loading';
import Translator from '../../core/i18n';

const T = Translator.create();
const _logger = Log.create('change-password');

export class CChangePasswordQuestion extends Component<IChangePasswordQuestion, any> {

    public closeButtonRef:HTMLButtonElement|null = null;

    constructor(props:any) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }

    public onSubmit(values: any) {
        this.props.dispatch(Actions.changePasswordQuestionAction(values, 'changePasswordQuestionLoading', 'get'));
    }

    public componentDidUpdate(prevProps: any) {
        if(this.props.isChangePasswordQuestion === true) {
            if(this.closeButtonRef) {
                this.closeButtonRef.click();
            }
        }
    }

    public render() {
        const initialFormValues = {
            userId: this.props.userId
        };
        return (
            <Formik
                initialValues={initialFormValues}
                onSubmit={this.onSubmit}
                validationSchema={getValidation}
                /* tslint:disable-next-line */
                render={propsFormik => (
                <form onSubmit={propsFormik.handleSubmit}>
                    <div className="modal change-password" id="change-password-question" tabIndex={-1} role="dialog">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                        <Loading top={'40%'} spinnerId={'changePasswordQuestionLoading'} />
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{T.t('r_change_security_question')}</h5>
                                    <button ref={e => this.closeButtonRef=e} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <p>{T.t('r_define_question_fields')}</p>
                                <Input
                                    type={'text'}
                                    name={'oldPassword'}
                                    label={'Eski Şifre'}
                                    placeHolder={T.t('r_enter_current_password')}
                                    formik={propsFormik}
                                />
                                <Input 
                                    type={'text'}
                                    name={'passwordSecurtiyQuestion'}
                                    placeHolder={T.t('r_new_security_question')}
                                    formik={propsFormik}
                                />
                                <Input 
                                    type={'text'}
                                    name={'passwordSecurtiyQuestionAnswer'}
                                    placeHolder={T.t('r_security_question_answer')}
                                    formik={propsFormik}
                                />
                                <div className="modal-footer border-0 mini-btn">
                                    <button type="button" data-dismiss="modal" className="btn btn-gray min-auto">{T.t('r_cancel_button')}</button>
                                    <button onClick={() => propsFormik.submitForm()} name={'changePasswordQuestionSave'} type="button" className="btn btn-green min-auto">{T.t('r_save_button')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}
            />
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IChangePasswordQuestion): IChangePasswordQuestion => {
    if (!state) {
        return ownProps;
    }

    const newProps:IChangePasswordQuestion = Object.assign({}, ownProps, {
        userId: state.login.identitiy.userId,
        isChangePasswordQuestion: state.profile.isChangePasswordQuestion
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.login.identitiy === prev.login.identitiy &&
        next.profile.isChangePasswordQuestion === prev.profile.isChangePasswordQuestion
    );
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const ChangePassword = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CChangePasswordQuestion);

export default ChangePassword;
